import React, { useState } from "react";
import {
  endInteraction,
  setcontactlist,
} from "../../../../Redux/Actions/actions";
import { connect } from "react-redux";
import axios from "axios";
import { BaseUrl } from "../../../../Container/BaseUrl/BaseUrl";
import { toast } from "react-toastify";
import { IoCloseCircle } from "react-icons/io5";
import {
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import { toaststyle } from "../../../../Utils/toaststyle";
const mapStateToProps = (state) => {
  return {
    chatid: state.data.chatid,
    chat: state.data.chat,
    externalChatData: state.data.externalChatData,
  };
};

const CannedMessage = ({
  showcannedmodal,
  handleClose,
  retrieveScannedMsg,
}) => {
  const [createMsg, setCreateMsg] = useState("");
  const [submitClicked, setSubmitClicked] = useState(false);

  const create_contact = () => {
    const access_token = localStorage.getItem("access_token");
    const datas = JSON.parse(localStorage.getItem("tokenAgent"));

    if (createMsg === "") {
      setSubmitClicked("Please create a canned message.");
      toast.warning("Message is missing", toaststyle);
    }

    let data = {
      message: createMsg,
      agent_id: datas.agent_id,
    };
    axios
      .post(BaseUrl + "/scannedMessage/createMessage", data, {
        headers: {
          Authorization: "Bearer " + access_token,
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.status) {
          toast.success("Canned Message Added", toaststyle);
          handleClose();
          retrieveScannedMsg();
        }
      })
      .catch((error) => {
        if (error.response.data.message == "Message Already exist") {
          toast.warning("Message Already exist", toaststyle);
        }
      });
  };

  return (
    <>
      {/* create canned message modal */}
      <Dialog
        open={showcannedmodal}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth maxWidth="sm"
      >
        <DialogTitle
          variant="subtitle2"
          sx={{ fontSize: "16px", fontWeight: 600, color: "#0b3363", boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px" }}
        >
          Create canned message

        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Box className="mt-3">
              <div className="mb-3">
                <label for="exampleFormControlInput1" className="form-label fs-13">Enter pre-written reply</label>
                <input type="text" className="form-control fs-13 form-control-lg"
                  value={createMsg}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (inputValue.length <= 1000) {
                      setCreateMsg(inputValue);
                      setSubmitClicked("");
                    } else {
                      setCreateMsg(inputValue.slice(0, 1000));
                      setSubmitClicked(
                        "Maximum character limit (1000) reached."
                      );
                    }
                  }}
                />
                <span className="input-highlight"></span>
              </div>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="error" size="small" sx={{ textTransform: "capitalize !important" }}>Close</Button>
          <Button variant="contained" onClick={create_contact} disableElevation size="small" sx={{ textTransform: "capitalize !important" }}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default connect(mapStateToProps, {
  endInteraction,
  setcontactlist,
})(CannedMessage);
